import { render, staticRenderFns } from "./ImportPluggy.vue?vue&type=template&id=497b032b&"
import script from "./ImportPluggy.vue?vue&type=script&lang=js&"
export * from "./ImportPluggy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports